<div id="load" *ngIf="isFpLoader" style="visibility: hidden;">
    <div id="load-inner"><img src="assets/img/{{env.host.name}}/logo.png" class="logo-login"> <i class="fa fa-spinner fa-spin"></i></div>
</div>

<div id="loadInner" *ngIf="!isFpLoader" >
    
    <div id="load-inner"><i class="fa fa-spinner fa-spin"></i></div>
</div>